import stores from "@/stores"
import dayjs from "@/utils/dayjs"
import { hasChosenPlan } from "@/utils/plan"

import DowngradePanel, { DowngradeFeature } from "./content/DowngradePanel"
import { showConfirmModal } from "./showConfirmModal"

export const showDowngradeModal = (props: {
  onConfirm: () => Promise<any> | any
  package_kind: number
}) => {
  const currentToDowngrade = `${stores.PlanStore.config?.user_pkg?.package_kind}-${props.package_kind}`
  const featureMap: Record<string, DowngradeFeature[]> = {
    // Essential → Free
    "2-1": [
      { text: "Block rules" },
      { text: "Refund to gift card" },
      { text: "Restocking fee & shipping fee" },
      { text: "Refund to store discount" },
      { text: "Multi-language" },
      { text: "Return reward" },
      { text: "Many more other Essential features..." },
    ],
    // Professional → Free
    "3-1": [
      { text: "Automation & workflows" },
      { text: "Block rules" },
      { text: "Replace & exchange item" },
      { text: "Restocking fee & shipping fee" },
      { text: "Refund to gift card" },
      { text: "Return reward" },
      { text: "Refund to store credit" },
      { text: "Integration" },
      { text: "Many more other Professional features..." },
    ],
    // Professional → Essential
    "3-2": [
      { text: "Automation & workflows" },
      { text: "Refund to store credit" },
      { text: "Exchange item" },
      { text: "Returns data export" },
      { text: "Many more other Professional features..." },
    ],
    // Enterprise → Free
    "4-1": [
      { text: "Automation & workflows" },
      { text: "Block rules" },
      { text: "Returns webhooks" },
      { text: "Restocking fee & Shipping fee" },
      { text: "Replace & exchange item" },
      { text: "Return reward" },
      { text: "Refund to gift card" },
      { text: "Integration" },
      { text: "Refund to store credit" },
      { text: "Packing slip" },
      { text: "Many more other Enterprise features..." },
    ],
    // Enterprise → Essential
    "4-2": [
      { text: "Automation & workflows" },
      { text: "Refund to store credit" },
      { text: "Returns webhooks" },
      { text: "Returns data export" },
      { text: "Exchange item" },
      { text: "Integration" },
      { text: "Many more other Enterprise features..." },
    ],
    // Enterprise → Professional
    "4-3": [
      { text: "Returns webhooks" },
      { text: "Dedicated priority support" },
      { text: "Many more other Enterprise features..." },
    ],
  }

  const isFirstChooseFree = !hasChosenPlan() && props.package_kind === 1
  const features = featureMap[currentToDowngrade]

  const userPkg = stores.PlanStore.config?.user_pkg
  const isInTrial =
    (userPkg?.rest_trial_days ?? 0) > 0 || (userPkg?.rest_seconds ?? 0) > 0

  const effectiveDateText =
    !isInTrial && !isFirstChooseFree
      ? t("DemotionModelText", {
          replace: {
            date: dayjs
              .unix(stores.PlanStore.config?.user_pkg?.cur_period_end ?? 0)
              .format("MMM DD, YYYY"),
          },
        })
      : undefined

  if (isFirstChooseFree) {
    showConfirmModal({
      title: "Choose free plan?",
      onConfirm: props.onConfirm,
      message: (
        <DowngradePanel
          features={[
            { text: "Automation & workflows" },
            { text: "Email notifications" },
            { text: "Replace & exchange item" },
            { text: "Block rules" },
            { text: "Refund to gift card" },
            { text: "Restocking fee & Shipping fee" },
            { text: "Refund to store credit" },
            { text: "Return reward" },
            { text: "And more" },
          ]}
          title={t("TheseFeaturesWillBeDisabledIfYouC")}
        />
      ),
      extraPrimaryAction: {
        content: "Choose free plan",
      },
      extraCancelAction: {
        content: t("Cancel"),
      },
    })
    return
  }
  showConfirmModal({
    title: t("DowngradeReminder"),
    onConfirm: props.onConfirm,
    message: features?.length ? (
      <DowngradePanel
        features={features}
        effectiveDateText={effectiveDateText}
      />
    ) : (
      t("DemotionModelText", {
        replace: {
          date: dayjs
            .unix(stores.PlanStore.config?.user_pkg?.cur_period_end ?? 0)
            .format("MMM DD, YYYY"),
        },
      })
    ),
    extraPrimaryAction: {
      content: t("Downgrade"),
      destructive: true,
    },
    extraCancelAction: {
      content: t("Cancel"),
    },
  })
}
